import "./NumberInputComp.css";
import { defineComponent as p, resolveComponent as l, openBlock as c, createElementBlock as h, withDirectives as m, createVNode as o, withCtx as n, vShow as r, createElementVNode as s, toDisplayString as b } from "vue";
import { OverflowComp as f } from "./OverflowComp.js";
import { ButtonComp as v } from "./ButtonComp.js";
import { IconComp as _ } from "./IconComp.js";
import { _ as w } from "./_plugin-vue_export-helper.dad06003.js";
const I = p({
  components: {
    OverflowComp: f,
    ButtonComp: v,
    IconComp: _
  },
  data() {
    return {
      tooltip: "",
      show: !1
    };
  },
  props: {
    value: {
      type: Number,
      note: "The value of the input"
    },
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: 1e4
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    multiValue: {
      type: Boolean,
      default: !1,
      note: "When multiple items are bound to this component and have different numeric values, we want to show <code>--</code> and only allow typed input."
    },
    numberInputId: {
      type: String,
      default: "",
      note: "This Id is used for accessibility and screen readers"
    }
  },
  methods: {
    increment() {
      const e = this.value ? this.value + 1 : 1;
      this.validate(e);
    },
    decrement() {
      const e = this.value ? this.value - 1 : 1;
      this.validate(e);
    },
    handleInput(e) {
      const t = e.target.value || "";
      this.validate(t);
    },
    validate(e) {
      let t = parseInt(e.toString());
      isNaN(t) || (t > this.max ? (t = this.max, this.tooltip = `The maximum is ${this.max}`, this.show = !0) : t < this.min && (t = this.min, this.tooltip = `The minimum is ${this.min}`, this.show = !0), this.$emit("onInput", t));
    },
    closeTooltip() {
      this.show = !1;
    }
  },
  watch: {
    max() {
      this.validate(this.value ?? "");
    }
  }
});
const y = { class: "container" }, C = ["min", "max", "value", "disabled", "id", "placeholder"], g = { class: "content__tooltip" };
function k(e, t, N, V, $, T) {
  const i = l("icon-comp"), d = l("button-comp"), u = l("overflow-comp");
  return c(), h("div", y, [
    m(o(d, {
      class: "container__button container--marginRight",
      onClick: e.decrement,
      blank: "",
      disabled: e.disabled
    }, {
      default: n(() => [
        o(i, {
          icon: "remove_small",
          label: "Subtract"
        })
      ]),
      _: 1
    }, 8, ["onClick", "disabled"]), [
      [r, !e.disabled]
    ]),
    o(u, {
      show: e.show,
      gray: "",
      arrow: "",
      tooltip: "",
      disabled: !e.show,
      zIndex: "10"
    }, {
      button: n(() => [
        s("input", {
          class: "number container--marginRight",
          type: "number",
          pattern: "^[0-9]*$",
          min: e.min,
          max: e.max,
          value: e.value,
          disabled: e.disabled,
          id: e.numberInputId,
          onInput: t[0] || (t[0] = (a) => e.handleInput(a)),
          placeholder: e.multiValue ? "––" : ""
        }, null, 40, C)
      ]),
      content: n(() => [
        s("div", {
          class: "content",
          onClick: t[1] || (t[1] = (...a) => e.closeTooltip && e.closeTooltip(...a))
        }, [
          s("span", g, b(e.tooltip), 1),
          o(i, {
            color: "white",
            class: "content__button",
            icon: "close_small",
            label: "Close"
          })
        ])
      ]),
      _: 1
    }, 8, ["show", "disabled"]),
    m(o(d, {
      class: "container__button",
      onClick: e.increment,
      blank: "",
      disabled: e.disabled
    }, {
      default: n(() => [
        o(i, {
          icon: "add_small",
          label: "Add"
        })
      ]),
      _: 1
    }, 8, ["onClick", "disabled"]), [
      [r, !e.disabled]
    ])
  ]);
}
const A = /* @__PURE__ */ w(I, [["render", k], ["__scopeId", "data-v-a72ffb94"]]);
export {
  A as NumberInputComp
};
//# sourceMappingURL=NumberInputComp.js.map
